// extracted by mini-css-extract-plugin
export default {"container":"ep-z","ratingLayout":"fp-z","ratingLabel":"gp-z","nonInteractiveRatingLabel":"hp-z"};